import { render, staticRenderFns } from "./DeliveryPerformance.vue?vue&type=template&id=1df0fde8&scoped=true"
import script from "./DeliveryPerformance.vue?vue&type=script&lang=js"
export * from "./DeliveryPerformance.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPerformance.vue?vue&type=style&index=0&id=1df0fde8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df0fde8",
  null
  
)

export default component.exports